import React from "react";

const SiteFooter = () => (
  <div className="siteFooter">
    Copyright &copy; {new Date().getFullYear()}{" "}
    <a href="//www.dreamchimney.com/" target="_top">
      Dream Chimney
    </a>{" "}
    Inc.
  </div>
);

export default SiteFooter;
